module.exports = __webpack_public_path__ + "static/media/pause.1d0f35ae.svg";